import React from 'react';

const SeoMainImage = ({ seo }) => {
  if (!seo?.mainImage) return null;
  return (
    <div style={{ marginTop: '80px', width: '100%', lineHeight: 0 }} data-testid="seo-main-image-wrapper">
      <img
        src={seo.mainImage}
        alt={seo.mainImageAlt || ''}
        title={seo.mainImageTitle || ''}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
        }}
        data-testid="seo-main-image"
      />
    </div>
  );
};

export default SeoMainImage;
